import { useCallback, useEffect, useState } from 'react';
const isJson = (str)=>{
    try {
        JSON.parse(str);
    } catch (_e) {
        return false;
    }
    return true;
};
const useIsStateReady = (waitForState, useRouteChanged)=>{
    const [stateResolved, setStateResolved] = useState(null);
    const handleRouteChange = useCallback(({ search })=>{
        if (waitForState && stateResolved == null) {
            const searchParams = new URLSearchParams(search || '');
            const state = searchParams.get('state');
            if (!state || !isJson(state)) {
                setStateResolved(Boolean(state));
            }
        }
    }, [
        waitForState,
        stateResolved
    ]);
    useEffect(()=>{
        if (typeof window !== 'undefined') {
            handleRouteChange({
                pathname: window?.location?.pathname,
                search: window?.location?.search
            });
            const handleUrlChange = ()=>{
                handleRouteChange({
                    pathname: window?.location?.pathname,
                    search: window?.location?.search
                });
            };
            window?.addEventListener('popstate', handleUrlChange);
            return ()=>{
                window?.removeEventListener('popstate', handleUrlChange);
            };
        }
    }, [
        handleRouteChange
    ]);
    useRouteChanged?.(handleRouteChange);
    if (!waitForState) {
        return {
            isLoaded: true,
            isError: false
        };
    }
    if (typeof window === 'undefined') {
        return {
            isLoaded: !waitForState,
            isError: false
        };
    }
    return {
        isLoaded: stateResolved != null,
        isError: stateResolved === false
    };
};
export default useIsStateReady;
